'use strict';

var $ = require('jquery');

$(function() {
	$('.page-template-template-fullwidth .iframe-wrapper').removeClass('iframe-wrapper');
    $('.page-template-template-fullwidth iframe').iFrameResize();
});